import { addBaseUrl } from "./addBaseUrl";
import { WebPageSEO } from "./WebPageSEO";

import type { JSX } from "react";

// // // //

interface AssetClassPageSEOProps {
    route: string;
    description: string;
}

/**
 * Renders WebPage JSON-LD structured data for asset class list pages.
 * Used on /treasuries, /stablecoins, /credit, /stocks, /commodities,
 * /government-bonds, /real-estate, /private-equity-venture-capital,
 * and /active-strategies.
 *
 * NOTE - `lastReviewed` is computed at render time, so render this from a
 * server component. In a client component the SSR and hydration timestamps
 * differ and React reports a mismatch.
 */
export function AssetClassPageSEO(props: AssetClassPageSEOProps): JSX.Element {
    const { route, description } = props;

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageSEO
            id={addBaseUrl(route)}
            description={description}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
